import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getAllOrders } from "../../actions/gameSettings";
import { getParlayOpenSpots } from "../../actions/gameSettings";
import { Link, useNavigate, useHistory } from "react-router-dom";
import DataFetchStatus from "../../common/DataFetchStatus";
import { formatOdds, formatPoint, formatTotalPoint } from "../../../utility/odds";
import { isDTS } from "../../../utility/platform";
import { straightBetPath } from "../../../constants/routes";
import { getTerm } from "../../../utility/complianceCopy";

const FillOpenContent = () => {
  const accountData = useSelector((state) => state.account);

  const [allOrders, setallOrders] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    fetchAllOrders();
  }, [accountData]);

  const fetchAllOrders = async () => {
    if (!accountData?.emailId) {
      setLoading(false);
      setallOrders([]);
      return;
    }
    setLoading(true);
    setFetchError(null);
    try {
      let { status, message, result } = await getParlayOpenSpots({
        email: accountData.emailId,
      });
      if (status == true) {
        const sortedResult = [...(result || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setallOrders(sortedResult);
      } else {
        setFetchError(message || "Unable to load open spots.");
        setallOrders([]);
      }
    } catch (err) {
      console.log("err", err);
      setFetchError("Unable to load open spots. Please try again.");
      setallOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const moveDash = async (id) => {
    try {
      // history.push(`/dashboard/${id}`);
      history.push(straightBetPath(id));

    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div className="">
      <div className="fo_tle_bg py-2 px-2 text-center">
        <p className="mb-0 ">
          {isDTS()
            ? `PLEASE SELECT THE ${getTerm("entry", { case: "upper" })} TO FILL`
            : "PLEASE SELECT THE BET TO FILL"}
        </p>
      </div>

      {/* table */}

      <DataFetchStatus loading={loading} error={fetchError}>
      <div>
        <Table responsive className="custom_table">
          {allOrders && allOrders.length > 0 ? (
            <thead>
              <tr>
                <th>Sport</th>
                <th>Description</th>
                <th className="text-center">Risk/win($)</th>
                <th className="text-center"></th>
              </tr>
            </thead>
          ) : (
            ""
          )}

          <tbody>
            {allOrders && allOrders?.length > 0 ? (
              allOrders?.map((item, index) => {
                return (
                  <tr>
                    <td>
                      {item?.betType == "Straight" ? (
                        <p>{item?.title}</p>
                      ) : (
                        item?.bettingData &&
                        item?.bettingData.map((bettingItem, index) => {
                          return <p>{bettingItem?.title}</p>;
                        })
                      )}
                    </td>
                    <td>
                      <p>
                        {item?.betType}{" "}
                        {item?.bettingData ? item?.bettingData.length : ""}
                      </p>
                      {item?.bettingData &&
                        item?.bettingData.map((bettingItem1, index) => {
                          return (
                            <>
                              {bettingItem1.homeTeam}
                              <p>
                                {bettingItem1.type}
                                <br></br>
                                {formatOdds(bettingItem1.price)}{" "}
                                {bettingItem1.point
                                  ? bettingItem1.type === "totals"
                                    ? formatTotalPoint(
                                        bettingItem1.point,
                                        bettingItem1.pointType || bettingItem1.teamName
                                      )
                                    : formatPoint(bettingItem1.point)
                                  : ""}{" "}
                                <br></br>({bettingItem1.homeTeam} VRS{" "}
                                {bettingItem1.awayTeam})
                              </p>
                            </>
                          );
                        })}
                    </td>
                    <td className="text-center">
                      <p>
                        {Number(item?.wagerAmount || 0).toFixed(2)} / {(Number(item?.payOut || 0) - Number(item?.wagerAmount || 0)).toFixed(2)}
                      </p>
                    </td>
                    <td className="text-center">
                      {item.isOpenFilled == false ? (
                        <div>
                          <button
                            className="img_btn"
                            onClick={() => moveDash(item._id)}>
                            Select
                          </button>
                        </div>
                      ) : item.isOpenScore == false ? (
                        "Pending"
                      ) : (
                        `Completed (${item.winStatus})`
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <th className="text-center">
                {isDTS()
                  ? `NO ${getTerm("entry", { plural: true, case: "upper" })} TO FILL`
                  : "NO BETS TO FILL"}
              </th>
            )}
          </tbody>
        </Table>
      </div>
      </DataFetchStatus>
    </div>
  );
};

export default FillOpenContent;
